import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '../../components/Layout'
import { useLoad, useRequest } from '../../hooks/request'
import { ANIMAL_TYPE_LIST } from '../../urls'

const ANIMAL_EMOJIS = [
    { emoji: '🐑', name: 'Қўй' },
    { emoji: '🐄', name: 'Сигир' },
    { emoji: '🐂', name: 'Ҳўкиз' },
    { emoji: '🐐', name: 'Эчки' },
    { emoji: '🐪', name: 'Туя' },
    { emoji: '🐴', name: 'От' },
    { emoji: '🐔', name: 'Товуқ' },
    { emoji: '🦆', name: 'Ўрдак' },
    { emoji: '🦃', name: 'Куркa' },
]

export default function AnimalTypes() {
    const history = useHistory()
    const animalTypes = useLoad({ url: ANIMAL_TYPE_LIST })
    const [showModal, setShowModal] = useState(false)
    const [editingType, setEditingType] = useState(null)
    const [formData, setFormData] = useState({ name: '', emoji: '', telegramGroupId: '' })

    const submitRequest = useRequest()

    const types = animalTypes.response?.results || []

    const handleCardClick = (typeId) => {
        history.push(`/animals/type/${typeId}`)
    }

    const openCreateModal = () => {
        setEditingType(null)
        setFormData({ name: '', emoji: '🐑', telegramGroupId: '' })
        setShowModal(true)
    }

    const openEditModal = (type, e) => {
        e.stopPropagation()
        setEditingType(type)
        setFormData({
            name: type.name,
            emoji: type.emoji || '🐑',
            telegramGroupId: type.telegramGroupId || ''
        })
        setShowModal(true)
    }

    const closeModal = () => {
        setShowModal(false)
        setEditingType(null)
        setFormData({ name: '', emoji: '', telegramGroupId: '' })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        const url = editingType
            ? `${ANIMAL_TYPE_LIST}/${editingType.id}`
            : ANIMAL_TYPE_LIST

        const method = editingType ? 'PUT' : 'POST'

        const result = await submitRequest.request({
            url,
            method,
            data: formData
        })

        if (result.response) {
            animalTypes.request()
            closeModal()
        }
    }

    const handleDelete = async (typeId, e) => {
        e.stopPropagation()

        if (!window.confirm('Ҳақиқатан ҳам бу турни ўчирмоқчимисиз?')) {
            return
        }

        const result = await submitRequest.request({
            url: `${ANIMAL_TYPE_LIST}/${typeId}`,
            method: 'DELETE'
        })

        if (result.response !== null) {
            animalTypes.request()
        }
    }

    return (
        <Layout className="has-background-light">
            <div className="container">
                <div className="mb-5">
                    <h1 className="title is-3 has-text-centered">
                        <ion-icon name="paw" style={{ verticalAlign: 'middle', marginRight: '10px' }} />
                        Ҳайвонлар
                    </h1>
                    <p className="subtitle is-6 has-text-centered has-text-grey">
                        Ҳайвон турларини танланг ва маълумотларни кўринг
                    </p>

                    <div className="has-text-centered mt-4">
                        <button className="button is-primary" onClick={openCreateModal}>
                            <span className="icon">
                                <ion-icon name="add-outline" />
                            </span>
                            <span>Янги тур қўшиш</span>
                        </button>
                    </div>
                </div>

                {animalTypes.loading && (
                    <div className="has-text-centered" style={{ padding: '60px' }}>
                        <button className="button is-loading is-ghost is-large" />
                    </div>
                )}

                {!animalTypes.loading && types.length === 0 && (
                    <div className="box has-text-centered" style={{ padding: '60px' }}>
                        <ion-icon name="file-tray-outline" style={{ fontSize: '64px', color: '#ccc' }} />
                        <p className="is-size-5 mt-4 has-text-grey">Ҳайвон турлари мавжуд эмас</p>
                        <p className="has-text-grey-light">Илтимос, аввал ҳайвон турларини қўшинг</p>
                    </div>
                )}

                {!animalTypes.loading && types.length > 0 && (
                    <div className="columns is-multiline">
                        {types.map((type) => (
                            <div key={type.id} className="column is-one-third">
                                <div
                                    className="box has-background-white"
                                    style={{
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        borderRadius: '12px',
                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                        border: '2px solid transparent',
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)'
                                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.15)'
                                        e.currentTarget.style.borderColor = '#3273dc'
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)'
                                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)'
                                        e.currentTarget.style.borderColor = 'transparent'
                                    }}
                                    onClick={() => handleCardClick(type.id)}
                                >
                                    <div className="content">
                                        <div className="level mb-3">
                                            <div className="level-left">
                                                <div className="level-item">
                                                    <p className="title is-5" style={{ marginBottom: 0 }}>
                                                        <span style={{ fontSize: '1.5em', marginRight: '8px' }}>
                                                            {type.emoji || '🐾'}
                                                        </span>
                                                        {type.name}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {type.telegramGroupId && (
                                            <p className="has-text-grey-light is-size-7 mb-3">
                                                <ion-icon name="send-outline" style={{ verticalAlign: 'middle' }} />
                                                {' '}Telegram: {type.telegramGroupId}
                                            </p>
                                        )}

                                        <div className="level">
                                            <div className="level-item has-text-centered">
                                                <div>
                                                    <p className="heading">Жами</p>
                                                    <p className="title is-4" style={{ color: '#3273dc' }}>
                                                        {type.animalCount || 0}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="columns is-mobile is-multiline">
                                            <div className="column is-half">
                                                <div className="has-text-centered">
                                                    <p className="heading">Фаол</p>
                                                    <p className="title is-5" style={{ color: '#48c774' }}>
                                                        {type.activeCount || 0}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="column is-half">
                                                <div className="has-text-centered">
                                                    <p className="heading">Сотилди</p>
                                                    <p className="title is-5" style={{ color: '#3298dc' }}>
                                                        {type.soldCount || 0}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="column is-half">
                                                <div className="has-text-centered">
                                                    <p className="heading">Ўлди</p>
                                                    <p className="title is-5" style={{ color: '#f14668' }}>
                                                        {type.diedCount || 0}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="column is-half">
                                                <div className="has-text-centered">
                                                    <p className="heading">Йўқолди</p>
                                                    <p className="title is-5" style={{ color: '#ffdd57', textShadow: '0 0 1px rgba(0,0,0,0.2)' }}>
                                                        {type.lostCount || 0}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="buttons mt-4">
                                            <button
                                                className="button is-small is-info is-outlined"
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    handleCardClick(type.id)
                                                }}
                                            >
                                                <span className="icon">
                                                    <ion-icon name="eye-outline" />
                                                </span>
                                                <span>Кўриш</span>
                                            </button>
                                            <button
                                                className="button is-small is-warning is-outlined"
                                                onClick={(e) => openEditModal(type, e)}
                                            >
                                                <span className="icon">
                                                    <ion-icon name="create-outline" />
                                                </span>
                                                <span>Таҳрирлаш</span>
                                            </button>
                                            <button
                                                className="button is-small is-danger is-outlined"
                                                onClick={(e) => handleDelete(type.id, e)}
                                            >
                                                <span className="icon">
                                                    <ion-icon name="trash-outline" />
                                                </span>
                                                <span>Ўчириш</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Create/Edit Modal */}
            <div className={`modal ${showModal ? 'is-active' : ''}`}>
                <div className="modal-background" onClick={closeModal} />
                <div className="modal-card">
                    <header className="modal-card-head">
                        <p className="modal-card-title">
                            {editingType ? 'Турни таҳрирлаш' : 'Янги тур қўшиш'}
                        </p>
                        <button className="delete" aria-label="close" onClick={closeModal} />
                    </header>
                    <section className="modal-card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="field">
                                <label className="label">Тур номи *</label>
                                <div className="control">
                                    <input
                                        className="input"
                                        type="text"
                                        placeholder="Масалан: Қўйлар, Сигирлар"
                                        value={formData.name}
                                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="field">
                                <label className="label">Emoji *</label>
                                <div className="control">
                                    <div className="buttons has-addons is-centered" style={{ flexWrap: 'wrap' }}>
                                        {ANIMAL_EMOJIS.map((item) => (
                                            <button
                                                key={item.emoji}
                                                type="button"
                                                className={`button ${formData.emoji === item.emoji ? 'is-primary' : ''}`}
                                                onClick={() => setFormData({ ...formData, emoji: item.emoji })}
                                                style={{ fontSize: '2em', padding: '1.5rem' }}
                                                title={item.name}
                                            >
                                                {item.emoji}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                <p className="help has-text-centered mt-2">
                                    Танланган: <span style={{ fontSize: '2em' }}>{formData.emoji || '❓'}</span>
                                </p>
                            </div>

                            <div className="field">
                                <label className="label">Telegram Guruh ID</label>
                                <div className="control">
                                    <input
                                        className="input"
                                        type="text"
                                        placeholder="Масалан: -1003440886395"
                                        value={formData.telegramGroupId}
                                        onChange={(e) => setFormData({ ...formData, telegramGroupId: e.target.value })}
                                    />
                                </div>
                                <p className="help">
                                    Бу турга ҳайвон қўшилгanda шу гуруҳга хабар юборилади. Бўш қолдирсангиз асосий гуруҳга юборилади.
                                </p>
                            </div>

                            <div className="field is-grouped is-grouped-right mt-5">
                                <div className="control">
                                    <button type="button" className="button" onClick={closeModal}>
                                        Бекор қилиш
                                    </button>
                                </div>
                                <div className="control">
                                    <button
                                        type="submit"
                                        className={`button is-primary ${submitRequest.loading ? 'is-loading' : ''}`}
                                        disabled={submitRequest.loading}
                                    >
                                        {editingType ? 'Сақлаш' : 'Қўшиш'}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </section>
                </div>
            </div>
        </Layout>
    )
}
